/**
 * Klab People Service API — Work Schedules Export
 * Manually added to expose POST /api/v1/work-schedules/export.
 */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';

@Injectable({ providedIn: 'root' })
export class PeopleWorkSchedulesService {

    protected basePath = '';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration: Configuration,
    ) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof basePath === 'string') {
            this.basePath = basePath;
        } else if (Array.isArray(basePath) && basePath.length > 0) {
            this.basePath = basePath[0];
        } else if (this.configuration.basePath !== undefined) {
            this.basePath = this.configuration.basePath;
        }
    }

    /**
     * Export work schedule catalog (CSV/Excel). Streams the file as a Blob.
     */
    public exportWorkSchedules(format: string, context?: HttpContext): Observable<Blob> {
        let localVarHeaders = this.defaultHeaders;
        localVarHeaders = localVarHeaders.set('Content-Type', 'application/json');

        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('post', `${basePath ?? this.basePath}/api/v1/work-schedules/export`,
            {
                context,
                body: { format },
                responseType: 'blob',
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: 'body',
                reportProgress: false,
            }
        );
    }
}
